import { api } from "assets/scripts/utilities/api-clients";

const transform = (pr) => {
  const { bill_id, seller, invc_id, ...rest } = unref(pr);

  return {
    bill_id: bill_id?._id || bill_id,
    seller: seller?._id || seller,
    invc_id: invc_id?._id || invc_id || null,
    ...rest,
  };
};

export const approve = async (pr) => {
  try {
    const { _id, reason = null, source } = pr;

    const response = await api.put("/kam/paymentrequests/approve", {
      _id,
      reason,
      source,
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const selfApprove = async (pr) => {
  try {
    const {
      _id,
      financial_summary,
      used_credits,
      is_used_credits,
      net_payable,
      remarks,
      requestor,
      source,
      tds,
      total_amount,
      net_amount,
      seller,
    } = pr;

    const response = await api.put("/account/paymentrequests/self-approve", {
      _id,
      financial_summary,
      used_credits,
      is_used_credits,
      net_payable,
      remarks,
      requestor,
      source,
      tds,
      net_amount,
      total_amount,
      seller_id: seller?._id,
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const cancel = async (pr) => {
  const response = await api.put("/account/paymentrequests/cancel", {
    _id: pr._id,
    reason: pr.reason,
  });

  return response;
};

export const hold = async (pr) => {
  const response = await api.put("/account/paymentrequests/hold", pr);

  return response;
};

export const count = async () => {
  const response = await api.get("/account/paymentrequests/count");

  return response;
};

export const generate = async (pr) => {
  const response = await api.put("/account/paymentrequests/generate", pr);

  return response;
};

export const get = async (id, role = "account") => {
  const response = await api.get(`/${role}/paymentrequests/${id}`);

  return response;
};

export const getInvoices = async (options) => {
  const response = await api.get("/account/paymentrequests/invoices", options);

  return response;
};

export const getMissedInvoices = async (options) => {
  const response = await api.get(
    "/account/paymentrequests/missed-pr-invoices",
    options,
  );

  return response;
};

export const index = async (options = {}) => {
  const response = await api.get("/account/paymentrequests", options);

  return response;
};

export const initiate = async (pr) => {
  try {
    const { _id } = pr;

    const response = await api.put("/account/paymentrequests/initiate", {
      _id,
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getPastPR = async (options = {}) => {
  const response = await api.get(`/account/paymentrequests/past`, options);

  return response;
};

export const getCreditDebitNotes = async (options = {}) => {
  const response = await api.get(
    "/account/paymentrequests/credit-debit-notes",
    options,
  );

  return response;
};

export const post = async (pr) => {
  const response = await api.post("/payment-requests", pr);

  return response;
};

export const put = async (pr) => {
  const response = await api.put("/payment-requests", pr);

  return response;
};

export const putAdvanceRequest = async (pr) => {
  try {
    const {
      approvers,
      adjustments,
      bill_id,
      invc_id,
      financial_summary,
      net_amount,
      net_payable,
      remarks,
      requestor,
      seller,
      total_amount,
      total_tax,
      percentage_pay,
      payment_has_tax,
      request_against,
      payment_received_date,
    } = transform(pr);

    const response = await api.put(
      "/kam/paymentrequests/send-advance-request-for-approval",
      {
        approvers,
        adjustments,
        bill_id,
        financial_summary,
        net_amount,
        net_payable,
        remarks,
        requestor,
        seller_id: seller,
        total_amount,
        total_tax,
        percentage_pay,
        payment_has_tax,
        request_against,
        invc_id,
        payment_received_date,
      },
    );

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const process = async (pr) => {
  const response = await api.put("/account/paymentrequests/process", pr);

  return response;
};

export const sendForApproval = async (pr) => {
  try {
    const {
      _id,
      financial_summary,
      used_credits,
      approvers,
      is_used_credits,
      net_payable,
      remarks,
      requestor,
      tds,
      net_amount,
      seller,
      total_amount,
      payments_made,
      associated_payments,
    } = pr;

    const response = await api.put(
      "/account/paymentrequests/send-for-approval",
      {
        _id,
        financial_summary,
        used_credits,
        approvers,
        is_used_credits,
        net_payable,
        remarks,
        requestor,
        tds,
        net_amount,
        total_amount,
        seller_id: seller?._id,
        payments_made,
        associated_payments,
      },
    );

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const processBulkInitiate = async (prs) => {
  try {
    const _ids = prs.map((pr) => pr._id).join(",");
    const payload = {
      pr_ids: _ids,
    };
    const response = await api.put(
      "/account/paymentrequests/bulk-initiate",
      payload,
    );

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const processInBulk = async (prs) => {
  try {
    const data_list = prs.map((pr) => {
      return {
        _id: pr["ID"],
        from_bank: pr["Poshn Bank Code"],
        utr: pr["UTR"],
        description: pr["Description"],
        transfer_mode: pr["MODE"],
      };
    });
    const payload = {
      data_list: data_list,
    };
    const response = await api.put(
      "/account/paymentrequests/bulk-process",
      payload,
    );

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const putOneClickBulkProcess = async (payload) => {
  try {
    const response = await api.put(
      "/account/paymentrequests/one-click-bulk-process",
      payload,
    );

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const putCancelPaymentRequestProcessing = async (payload) => {
  try {
    const response = await api.put(
      "/account/paymentrequests/cancel-payment-processing",
      payload,
    );

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const putSendOTPForPRsProcessing = async (payload) => {
  try {
    const response = await api.put(
      "/account/paymentrequests/send-otp",
      payload,
    );

    return response;
  } catch (error) {
    console.error(error);
  }
};
